import { Button, Card, Table, Tag } from "antd";
import { Doughnut, Bar } from "react-chartjs-2";
import
{
      Chart as ChartJS,
      ArcElement,
      Tooltip,
      Legend,
      CategoryScale,
      LinearScale,
      BarElement,
} from "chart.js";
import ContentLayoutManagement from "../../layouts/ContentLayoutManagement";
import CommonIcons from "../../assets/icons";
import { useNavigate } from "react-router-dom";
import { PlusOutlined, RightOutlined } from "@ant-design/icons";
import HeaderContent from "../../layouts/HeaderContent";

ChartJS.register(
      ArcElement,
      Tooltip,
      Legend,
      CategoryScale,
      LinearScale,
      BarElement
);

export default function HomePage()
{

      const navigate = useNavigate()
      const stats = [
            { title: "Tổng đơn hàng", value: "1430", icon: <CommonIcons.DashboardTotalOrderIcon /> },
            { title: "Đang xử lý", value: "24", icon: <CommonIcons.DashboardPendingIcon /> },
            { title: "Diện tích phủ (km²)", value: "842.5k", icon: <CommonIcons.DashboardCoverIcon /> },
            { title: "Dung lượng lưu trữ", value: "12.4 TB", icon: <CommonIcons.DashboardStorageIcon /> },
      ];

      const donutData = {
            labels: ["Hoàn thành", "Đang xử lý", "Đã hủy"],
            datasets: [
                  {
                        data: [63, 22, 8],
                        backgroundColor: ["#22c55e", "#facc15", "#ef4444"],
                        borderWidth: 0
                  },
            ],
      };

      const barData = {
            labels: ["Cosmos", "Capella", "Planet"],
            datasets: [
                  {
                        label: "Orders",
                        data: [350, 820, 260],
                        backgroundColor: "#38bdf8",
                        barThickness: 32, // giảm chiều cao thanh
                        borderRadius: 8,  // bo góc
                  },
            ],
      };

      const columns: any = [
            {
                  title: "Tên đơn",
                  dataIndex: "name",
            },
            {
                  title: "Loại đặt",
                  dataIndex: "type",
                  render: (type?: string) =>
                  {
                        return <span className="flex gap-2 items-center text-center">{type === 'Đặt ảnh mới' ? <CommonIcons.ExploreTaskingIcon /> : <CommonIcons.ExploreArchiveIcon />} {type}</span>
                  }
            },
            {
                  title: "Hãng",
                  dataIndex: "brand",
            },
            {
                  title: "Status",
                  dataIndex: "status",
                  render: (status?: any) =>
                  {
                        const map: any = {
                              done: <Tag className="custom-tag-status bg-[#66C56340] text-[#66C563] " >Đã đóng</Tag>,
                              cancel: <Tag className="custom-tag-status bg-[#FF577940] text-[#FF5779] " >Đã hủy</Tag>,
                              processing: <Tag className="custom-tag-status bg-[#FF577940] text-[#FF5779] " >Đang xử lý</Tag>,
                              confirmPrice: <Tag className="custom-tag-status bg-[#F8DE1640] text-[#F8DE16] ">Đang xác nhận báo giá</Tag>,
                        };
                        return map?.[status];
                  },
            },
            {
                  title: "Mức độ ưu tiên",
                  dataIndex: "priority",
                  render: (p?: any) =>
                  {
                        const map: any = {
                              low: <p className="text-[#00E676]">Thấp</p>,
                              medium: <p className="text-[#F8DE16]">Trung bình</p>,
                              high: <p className="text-[#FBA03C]">Cao</p>,
                              urgent: <p className="text-[#DD2C00]">Khẩn cấp</p>,
                        };
                        return map[p];
                  },
            },

            {
                  title: "",
                  key: "action",
                  align: "right",
                  render: (_: any, record: any) => (
                        <div className="flex items-center text-center  justify-end">
                              <Button
                                    type="link"
                                    onClick={() => navigate(`/orders/${record.key}`)}
                              >
                                    Chi tiết
                              </Button>

                              <Button
                                    className="!w-6 min-w-6 h-6"
                                    type="text"
                                    icon={<CommonIcons.NextIcon />}
                                    onClick={() => navigate(`/orders/${record.key}`)}
                              />
                        </div>
                  ),
            },


      ];

      const data = [
            {
                  key: 1,
                  name: "Order Archive 1102",
                  type: "Đặt ảnh mới",
                  brand: "COSMOS",
                  status: "done",
                  priority: "low",
            },
            {
                  key: 2,
                  name: "Order Archive 1103",
                  type: "Ảnh có sẵn",
                  brand: "SATVU",
                  status: "cancel",
                  priority: "medium",
            },
            {
                  key: 3,
                  name: "Order Archive 1102",
                  type: "Đặt ảnh mới",
                  brand: "COSMOS",
                  status: "processing",
                  priority: "low",
            },
            {
                  key: 4,
                  name: "Order Archive 1103",
                  type: "Ảnh có sẵn",
                  brand: "SATVU",
                  status: "processing",
                  priority: "urgent",
            },
            {
                  key: 5,
                  name: "Order Archive 1102",
                  type: "Đặt ảnh mới",
                  brand: "COSMOS",
                  status: "processing",
                  priority: "urgent",
            },
            {
                  key: 6,
                  name: "Order Archive 1103",
                  type: "Ảnh có sẵn",
                  brand: "SATVU",
                  status: "confirmPrice",
                  priority: "medium",
            },
            {
                  key: 7,
                  name: "Order Archive 1102",
                  type: "Đặt ảnh mới",
                  brand: "COSMOS",
                  status: "confirmPrice",
                  priority: "low",
            },
            {
                  key: 8,
                  name: "Order Archive 1103",
                  type: "Ảnh có sẵn",
                  brand: "SATVU",
                  status: "cancel",
                  priority: "medium",
            },
            {
                  key: 9,
                  name: "Order Archive 1102",
                  type: "Đặt ảnh mới",
                  brand: "COSMOS",
                  status: "done",
                  priority: "low",
            },
            {
                  key: 10,
                  name: "Order Archive 1103",
                  type: "Ảnh có sẵn",
                  brand: "SATVU",
                  status: "cancel",
                  priority: "medium",
            },
            {
                  key: 11,
                  name: "Order Archive 1102",
                  type: "Đặt ảnh mới",
                  brand: "COSMOS",
                  status: "done",
                  priority: "low",
            },
            {
                  key: 12,
                  name: "Order Archive 1103",
                  type: "Ảnh có sẵn",
                  brand: "SATVU",
                  status: "cancel",
                  priority: "medium",
            },
            {
                  key: 13,
                  name: "Order Archive 1102",
                  type: "Đặt ảnh mới",
                  brand: "COSMOS",
                  status: "done",
                  priority: "low",
            },
            {
                  key: 14,
                  name: "Order Archive 1103",
                  type: "Ảnh có sẵn",
                  brand: "SATVU",
                  status: "cancel",
                  priority: "medium",
            },
            {
                  key: 15,
                  name: "Order Archive 1102",
                  type: "Đặt ảnh mới",
                  brand: "COSMOS",
                  status: "done",
                  priority: "low",
            },
            {
                  key: 16,
                  name: "Order Archive 1103",
                  type: "Ảnh có sẵn",
                  brand: "SATVU",
                  status: "cancel",
                  priority: "medium",
            }, {
                  key: 17,
                  name: "Order Archive 1102",
                  type: "Đặt ảnh mới",
                  brand: "COSMOS",
                  status: "done",
                  priority: "low",
            },
            {
                  key: 18,
                  name: "Order Archive 1103",
                  type: "Ảnh có sẵn",
                  brand: "SATVU",
                  status: "cancel",
                  priority: "medium",
            },
            {
                  key: 19,
                  name: "Order Archive 1102",
                  type: "Đặt ảnh mới",
                  brand: "COSMOS",
                  status: "done",
                  priority: "low",
            },
            {
                  key: 20,
                  name: "Order Archive 1103",
                  type: "Ảnh có sẵn",
                  brand: "SATVU",
                  status: "cancel",
                  priority: "medium",
            },
            {
                  key: 21,
                  name: "Order Archive 1102",
                  type: "Đặt ảnh mới",
                  brand: "COSMOS",
                  status: "done",
                  priority: "low",
            },
            {
                  key: 22,
                  name: "Order Archive 1103",
                  type: "Ảnh có sẵn",
                  brand: "SATVU",
                  status: "cancel",
                  priority: "medium",
            },
            {
                  key: 23,
                  name: "Order Archive 1102",
                  type: "Đặt ảnh mới",
                  brand: "COSMOS",
                  status: "done",
                  priority: "low",
            },
            {
                  key: 24,
                  name: "Order Archive 1103",
                  type: "Ảnh có sẵn",
                  brand: "SATVU",
                  status: "cancel",
                  priority: "medium",
            }, {
                  key: 25,
                  name: "Order Archive 1102",
                  type: "Đặt ảnh mới",
                  brand: "COSMOS",
                  status: "done",
                  priority: "low",
            },
            {
                  key: 26,
                  name: "Order Archive 1103",
                  type: "Ảnh có sẵn",
                  brand: "SATVU",
                  status: "cancel",
                  priority: "medium",
            },
            {
                  key: 27,
                  name: "Order Archive 1102",
                  type: "Đặt ảnh mới",
                  brand: "COSMOS",
                  status: "done",
                  priority: "low",
            },
            {
                  key: 28,
                  name: "Order Archive 1103",
                  type: "Ảnh có sẵn",
                  brand: "SATVU",
                  status: "cancel",
                  priority: "medium",
            },
            {
                  key: 29,
                  name: "Order Archive 1102",
                  type: "Đặt ảnh mới",
                  brand: "COSMOS",
                  status: "done",
                  priority: "low",
            },
            {
                  key: 30,
                  name: "Order Archive 1103",
                  type: "Ảnh có sẵn",
                  brand: "SATVU",
                  status: "cancel",
                  priority: "medium",
            },
            {
                  key: 31,
                  name: "Order Archive 1102",
                  type: "Đặt ảnh mới",
                  brand: "COSMOS",
                  status: "done",
                  priority: "low",
            },
            {
                  key: 32,
                  name: "Order Archive 1103",
                  type: "Ảnh có sẵn",
                  brand: "SATVU",
                  status: "cancel",
                  priority: "medium",
            },

      ];

      const total = donutData.datasets[0].data.reduce((a, b) => a + b, 0);

      return (
            <ContentLayoutManagement
                  header={
                        <HeaderContent
                              breadcrumb={[
                                    { title: "Home" },
                                    // { title: "Orders" },
                              ]}
                        // extra={
                        //       <Button type="primary" icon={<PlusOutlined />}>
                        //             Thêm mới
                        //       </Button>
                        // }
                        />
                  }
            >
                  <div className="p-6 bg-[#0f172a] min-h-screen text-white space-y-6">

                        <h1 className="text-xl font-semibold">Tổng quan</h1>

                        {/* Stats */}
                        <div className="grid grid-cols-4 gap-4">
                              {stats.map((s, i) => (
                                    <Card
                                          key={i}
                                          className="card-dashboard text-white"
                                          bodyStyle={{ padding: 20 }}
                                    >
                                          <div className="bg-[var(--color-bg-icon)] mb-8 flex flex-col justify-center items-center rounded-2xl h-[64px] w-[64px]">{s?.icon}</div>

                                          <p className="text-gray-400 text-[16px] mb-2">{s.title}</p>
                                          <p className="text-xl font-bold">{s.value}</p>
                                    </Card>
                              ))}
                        </div>

                        {/* Charts */}
                        <div className="grid grid-cols-3 gap-4">

                              <Card
                                    title="Trạng thái đơn hàng"
                                    className="h-[400px] col-span-1 card-dashboard"
                                    headStyle={{ color: "white" }}
                              >
                                    <div className="flex items-center gap-[42px] h-[300px]">

                                          {/* Chart */}
                                          <div className="w-[180px] h-[180px]">
                                                <Doughnut
                                                      data={donutData}
                                                      options={{
                                                            maintainAspectRatio: false,
                                                            cutout: "65%",
                                                            plugins: { legend: { display: false } }
                                                      }}
                                                />
                                          </div>

                                          {/* Legend */}
                                          <div className="space-y-3 w-full">
                                                {donutData.labels.map((label, i) =>
                                                {
                                                      const value = donutData.datasets[0].data[i];
                                                      const percent = Math.round((value / total) * 100);
                                                      const color = donutData.datasets[0].backgroundColor[i];

                                                      return (
                                                            <div key={i} className="flex items-center gap-2 text-sm text-gray-300">

                                                                  <span
                                                                        className="w-3 h-3 rounded-full"
                                                                        style={{ backgroundColor: color }}
                                                                  />

                                                                  <span>
                                                                        {label}: {value} ({percent}%)
                                                                  </span>

                                                            </div>
                                                      );
                                                })}
                                          </div>

                                    </div>
                              </Card>

                              <Card
                                    title="Đơn đặt hàng theo nhà cung cấp"
                                    className="card-dashboard h-[400px] col-span-2"
                                    headStyle={{ color: "white" }}
                              >
                                    <Bar
                                          data={barData}
                                          height={280}
                                          options={{
                                                indexAxis: "y",
                                                plugins: { legend: { display: false } },
                                                maintainAspectRatio: false
                                          }}
                                    />
                              </Card>
                        </div>

                        {/* Table */}
                        <p>Lịch sử đặt ảnh</p>
                        <Table
                              columns={columns}
                              dataSource={data}
                              pagination={{
                                    pageSize: 10,
                                    total: data?.length,
                                    showTotal: (total, range) =>
                                          `Show ${range[0]} to ${range[1]} of ${total} records`,
                              }}
                        />
                  </div>
            </ContentLayoutManagement>

      );
}